/***
 * Copyright (c) Myia 2023-2025 - All Rights Reserved
 */

import { useSession } from '@clerk/clerk-react';
import { formatDistanceToNow } from 'date-fns';
import { useEffect, useState } from 'react';

export const ImpersonationCountdown = () => {
    const { session } = useSession();
    const [timeLeft, setTimeLeft] = useState<string>('');

    useEffect(() => {
        if (!session) return;

        const updateTimeLeft = () => {
            const sessionEnd = new Date(session.expireAt);
            setTimeLeft(formatDistanceToNow(sessionEnd, { addSuffix: true }));
        };

        updateTimeLeft();
        const interval = setInterval(updateTimeLeft, 1000);

        return () => clearInterval(interval);
    }, [session?.lastActiveToken?.jwt]);

    if (!session?.lastActiveToken?.jwt) return null;

    return (
        // eslint-disable-next-line max-len
        <div className="fixed top-0 left-1/2 transform -translate-x-1/2 bg-yellow-100 text-yellow-800 px-4 py-2 rounded-lg shadow-lg z-50">
            <p className="text-sm font-medium">Impersonation session ends {timeLeft} (approximate)</p>
        </div>
    );
};
